module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_5_2.a8c866d3.png";